import React, { createContext, useContext } from 'react'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Tooltip } from 'antd'
import Loading from '../../shared/Loading'
import ShiftMessagingIndicator from '../../shared/ShiftMessagingIndicator'

const EMPTY_CONTEXT = createContext()

const TooltipIconButton = ({
  className = '', context, disabled = false, dotStatus = 0, ghost, icon, iconColor, loading, overlayStyle = {}, placement = 'top', size = 'default', style, text, title, type = 'default',
  onClick = () => {}, onMouseEnter = () => {}, onMouseLeave = () => {}
}) => {
  const contextValue = useContext(context ?? EMPTY_CONTEXT)

  return (
    <Tooltip title={title} overlayStyle={overlayStyle} placement={placement}>
      <Button
        className={`flex-button ${className}`}
        disabled={disabled}
        ghost={ghost}
        size={size}
        style={style}
        type={type}
        onClick={context ? () => onClick(contextValue.setData) : onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        {!loading && (
          <FontAwesomeIcon icon={icon} color={iconColor} />
        )}
        {loading && <Loading />}
        {text && <span> &nbsp; {text}</span>}
        {dotStatus > 0 && <ShiftMessagingIndicator status={dotStatus} />}
      </Button>
    </Tooltip>
  )
}

export default TooltipIconButton
